import { Dayjs } from 'dayjs';

import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix, upsert } from '~support-at-home/actions/externalApiStatuses';

export interface ExternalApiStatus {
  id: string;
  company_id: number;
  provider_tag: string;
  api_tag: string;
  title: string;
  last_message: string;
  last_run: string | Dayjs;
  last_status: string;
}

const initialState: CommonState<ExternalApiStatus> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<ExternalApiStatus>, ExternalApiStatus>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
  extraReducers: (builder) => {
    builder.addCase(upsert.fulfilled, (state, action) => {
      state.loading = 'fulfilled';
      state.message = action.payload.message;
    });
  },
});

export default slice.reducer;
